/**
 * Перенос коротких слов (например, союзов и предлогов) с помощью неразрывного пробела.
 * Пример: "и в дом" -> "и&nbsp;в&nbsp;дом" (в реальности используются \u00A0).
 *
 * @param {string} text Строка, в которой нужно расставить неразрывные пробелы.
 * @param {number} wordLength Максимальная длина слова, после которого будет подставлен неразрывный пробел.
 * @returns {string} Строка с заменёнными пробелами после коротких слов.
 */
export function fixTypography(text, wordLength = 3) {
    if (!text) {
        return text;
    }

    const parts = text.split(' ');

    const processed = parts.map((part) => {
        if (part.length <= wordLength) {
            return part + '\u00A0';
        }

        return part + ' ';
    });

    return processed.join('');
}

/**
 * Обёртка для автоматического переноса коротких слов в текстовых нодах.
 *
 * @param {{ children: React.ReactNode }} props Пропсы компонента.
 * @returns {React.ReactNode} Обработанное типографикой содержимое.
 */
export function Typo({ children }) {
    if (typeof children !== 'string') {
        return children;
    }

    return fixTypography(children);
}


